// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-activity-ideation-stage-message{display:block}.task-activity-ideation-stage-message h4:first-child{margin-top:0}.task-activity-ideation-stage-message p:last-child{margin-bottom:0}.task-activity-ideation-stage-message__body{display:flex;align-items:center}.task-activity-ideation-stage-message__splitter{align-self:stretch;position:relative;width:1px;margin:0 15px;background-color:#f8f8f7}.task-activity-ideation-stage-message__content{flex-grow:1}", ""]);
// Exports
module.exports = exports;
